import { createContext, type RefObject, use } from "react";

/** Interface */
interface IImageCanvasContext {
	containerRef: RefObject<HTMLDivElement | null>;
	imageUrl: string;
}

/** Context */
export const ImageCanvasContext = createContext<IImageCanvasContext>({} as IImageCanvasContext);

export function useImageCanvasContext() {
	return use(ImageCanvasContext);
}
